<div class="main-container-wrapper">
  <div class="main-container">
    <div class="screens-filter-container">
      <h1 class="title">
        Liste des contrats {{ filter?.year ? " de l'année  " + filter.year : '' }}
        {{ selectedSeller ?
        (' de ' + selectedSeller.nomUt + ' (' + selectedSeller.codUt + ')') :
        '' }}
      </h1>
      <div>
        <app-contract-seller-filters
          (sellerChangeEmitter)="handleSellerChange($event)"
          (transferContractsEmitter)="handleTransferContractsEmitter($event)"
          [sellerList]="sellerList"
          [sellerToTransferList]="sellerToTransferList"
          [transferContracts]="transferContracts"
        ></app-contract-seller-filters>
      </div>
    </div>
    <div>
      <app-contract-seller-grid *ngIf="contractSellerItems"
        [contractSellerItems]="contractSellerItems"
        [contractSellerItemsList]="contractSellerItemsList"
        [sellerToTransfer]="sellerToTransfer"
        [isLoadingItems]="isLoadingItems"
        (contractToTransferListEvent)="handleContractToTransferListEvent($event)">
      </app-contract-seller-grid>
    </div>
  </div>
</div>
